import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '../context.jsx';
import { MagBtn } from './ui.jsx';

export default function Footer() {
  const { lang, t, CH, CL } = useApp();
  const nav = useNavigate();

  return (
    <>
      <div className="CTA-band">
        <div className="CTA-inner">
          <div className="CTA-text">
            {lang === 'ru' ? 'Готовы создать что-то особенное?' : 'Ready to create something special?'}
          </div>
          <MagBtn className="B1" onClick={() => nav('/contact')} onMouseEnter={CH} onMouseLeave={CL}>
            {lang === 'ru' ? 'Обсудить проект' : 'Discuss a project'}
          </MagBtn>
        </div>
      </div>

      <div className="MQ">
        <div className="MQ-inner" style={{ animationDirection: 'reverse' }}>
          <span className="MQ-text">{t.marquee.repeat(4)}</span>
        </div>
      </div>

      <footer className="F">
        <div className="F-social">
          <a href="https://t.me/lizadragon22" target="_blank" rel="noopener noreferrer" onMouseEnter={CH} onMouseLeave={CL} aria-label="Telegram">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
          </a>
          <a href="mailto:iesm144@yandex.ru" onMouseEnter={CH} onMouseLeave={CL} aria-label="Email">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
          </a>
        </div>
        <p className="F-t">
          © 2026 {lang === 'ru' ? 'Елизавета Федькина' : 'Elizaveta Fedkina'} — {t.footer}
          {' · '}
          <Link to="/privacy" onMouseEnter={CH} onMouseLeave={CL} style={{ color: 'inherit', textDecoration: 'underline', textUnderlineOffset: 3 }}>
            {lang === 'ru' ? 'Конфиденциальность' : 'Privacy'}
          </Link>
        </p>
        <p className="F-disclaimer" style={{ marginTop: 18, font: "400 11px/1.5 var(--sans)", color: "rgba(255,255,255,.45)", maxWidth: 640 }}>
          {lang === 'ru'
            ? '* Instagram принадлежит компании Meta Platforms Inc., признанной экстремистской организацией, её деятельность запрещена на территории Российской Федерации.'
            : '* Instagram is a product of Meta Platforms Inc., which is recognized as an extremist organization and whose activities are banned in the Russian Federation.'}
        </p>
      </footer>

      <a
        className="tg-float"
        href="https://t.me/lizadragon22"
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={CH}
        onMouseLeave={CL}
        aria-label="Telegram"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
      </a>
    </>
  );
}
